import { Theme } from "@mui/material";
import { SprKey, sprKeysAreEqual } from "../../SprKey";
import { DELETABLE_FIELD } from "../../../../Grid/GridConstants";

export const asDeletableSprs = (manuallyAddedSprs: SprKey[]) =>
  manuallyAddedSprs.map((it) => ({
    ...it,
    [DELETABLE_FIELD]: true,
  }));

export const EXCLUDED_FIELD = "isExcluded";
export const EXCLUDABLE_FIELD = "isExcludable";

export function asExcludableSprs(sprsMatchingFilters: SprKey[], excludedSprs: SprKey[]) {
  return sprsMatchingFilters.map((it) => {
    const isExcluded = excludedSprs.some((excludedSpr) => sprKeysAreEqual(excludedSpr, it));
    return {
      ...it,
      [EXCLUDABLE_FIELD]: !isExcluded,
      [EXCLUDED_FIELD]: isExcluded,
    };
  });
}

export const excludedSprsStyle = (theme: Theme) => ({
  backgroundColor: theme.palette.error.light,
  color: theme.palette.grey[200],
});
